import styled from "styled-components";

export function DotStatus({ text, color }: { text?: string; color?: string }) {
  return <DotStatusWrapper color={color}>{text}</DotStatusWrapper>;
}

const DotStatusWrapper = styled.div<{ color?: string }>`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 14px;
  &:before {
    content: ${({ color }) => (color ? "''" : "unset")};
    position: absolute;
    left: 0;
    width: 6px;
    height: 6px;
    background-color: ${({ color }) => color ?? "transparent"};
    border-radius: 50%;
  }
`;
